import HmRouterConfig from '@hm-common/options/router.options';

export default HmRouterConfig;
